'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _DropDown = require('../DropDown/DropDown');

var _DropDown2 = _interopRequireDefault(_DropDown);

var _Menu = require('../Menu/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _Icon = require('./components/Icon.MenuButton');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var MenuButton = function (_Component) {
  _inherits(MenuButton, _Component);

  function MenuButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuButton, [{
    key: 'renderButton',
    value: function renderButton() {
      var _props = this.props,
          size = _props.size,
          outline = _props.outline,
          theme = _props.theme,
          children = _props.children,
          icon = _props.icon;
      return _react2.default.createElement(_Button2.default, {
        size: size,
        outline: outline,
        theme: theme,
        icon: !!icon ? icon : !children ? this.icon() : null
      }, children ? _react2.default.createElement('span', null, children, !icon && _react2.default.createElement(_Icon2.default, {
        icon: this.icon()
      })) : null);
    }
  }, {
    key: 'render',
    value: function render() {
      var open = this.props.open;
      var visible = this.state.visible;
      return _react2.default.createElement(_DropDown2.default, {
        visible: visible,
        onOpen: this.open,
        onClose: this.close,
        trigger: this.renderButton()
      }, _react2.default.createElement(_Menu2.default, {
        options: this.options(),
        open: open
      }));
    }
  }]);

  return MenuButton;
}(_react.Component);

MenuButton.propTypes = {
  size: _propTypes2.default.string,
  outline: _propTypes2.default.bool,
  theme: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  children: _propTypes2.default.node,
  options: _propTypes2.default.array,
  className: _propTypes2.default.string,
  open: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};
MenuButton.defaultProps = {
  size: 'normal',
  outline: false,
  theme: 'red',
  icon: null,
  children: null,
  options: [],
  open: 'none'
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = {
    visible: false
  };

  this.open = function () {
    if (_this2.state.visible) return;

    _this2.setState({
      visible: true
    });
  };

  this.close = function () {
    if (!_this2.state.visible) return;

    _this2.setState({
      visible: false
    });
  };

  this.icon = function () {
    return _this2.state.visible ? 'up' : 'down';
  };

  this.options = function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props.options;
    return [].concat(_toConsumableArray(options)).map(function (option) {
      var copy = _extends({}, option);

      if (copy.options) copy.options = [].concat(_toConsumableArray(_this2.options(copy.options)));

      if (copy.onClick) {
        var onClick = copy.onClick;

        copy.onClick = function () {
          _this2.close();

          onClick.apply(undefined, arguments);
        };
      }

      return copy;
    });
  };
};

exports.default = MenuButton;